import { Trans } from '@lingui/macro'
import React from 'react'

import logo from 'assets/images/logos/fanfare-energy-logo.png'
import backgroundImage from 'assets/images/fanfare-background.svg'
import { PAYMENT_PROVIDERS } from 'config'
import stockPhoto from 'assets/images/fanfareMockup/adobestock_558713128.jpg'
import fistBump from 'assets/images/fanfareMockup/fist_bump.svg'
import foamFinger from 'assets/images/fanfareMockup/foam_finger.svg'
import megaphone from 'assets/images/fanfareMockup/megaphone.svg'
import marqueeSign from 'assets/images/fanfareMockup/marquee_sign.svg'

// This config is based off of think not think-stripe
export const companyInfo = {
  name: 'Fanfare Energy',
  phone: '+1 (855) 955-5303', // TODO: check phone number
  phoneLink: '+18559555303',
  termsLink: 'https://www.fanfareenergy.com/terms/',
  privacyPolicyLink: 'https://fanfareenergy.com/privacy-policy',
  homepageLink: 'https://fanfareenergy.com',
  thankYouLink: 'https://www.fanfareenergy.com/enrollment-confirmed',
  iosAppLink: 'https://itunes.apple.com/us',
  androidAppLink: 'https://play.app.goo.gl/',
  faviconLink: 'https://static.cdn-website.com/runtime/favicon_d1_res.ico',
  forgotPasswordLink: 'https://myaccount.fanfareenergy.com/forgot-password',
  paymentProvider: PAYMENT_PROVIDERS.CHASE,
  chaseMerchantID: '441193',
  chaseSubscriberID: '100000000356',
  chaseSubscriberID_NTX: '100000000356',
  EFLLink: 'https://tx-stage.fanfareenergy.com/terms/',
  TOSYRACLink: 'https://tx-stage.fanfareenergy.com/terms/',
  customerPortalLink: 'https://myaccount.fanfareenergy.com',
  callingHours: <Trans>(Mon - Fri 9am - 6pm CST)</Trans>,
  contactLink: 'tel:+18559555303',
  customerPortalName: 'My Account',
  footerCertificate: <Trans>Elevate Energy, LLC dba Fanfare Energy is a Texas retail electric provider, PUCT License No. 10353</Trans>,
  supportEmail: 'care@fanfareenergy.com',
  noOffersPage_deprecated: 'https://fanfare.energy',
  confirmEmailPassword: true,
  plansAndRatesLink: 'https://fanfareenergy.com/plans-and-rates',
  aboutUsLink: 'https://fanfareenergy.com/about-us',
  blogLink: 'https://fanfareenergy.com/blog',
  mailingAddress: <p><Trans>Mailing Address</Trans>: P.O. Box 1288, Greens Farms, CT 06838</p>,
  businessAddress: <p><Trans>Business Address</Trans>: 2500 CityWest Blvd., STE 150, Houston, TX 77042</p>,
  expiration_days: '10',
}

// Values sampled from mockups
const BRAND_MOCKUP_YELLOW = '#dfd845' // highlights, cards
const BRAND_MOCKUP_ORANGE = '#e58740' // buttons
const BRAND_MOCKUP_LIGHT_ORANGE = '#ee964b' // price underlines
const BRAND_MOCKUP_NAVY = '#142955' // secondary buttons
const BRAND_MOCKUP_GREY = '#e9edf2' // secondary cards, sliders
const BRAND_MOCKUP_WHITE = '#fefefe' // background
const BRAND_MOCKUP_BLACK = '#0b141c' // text, footers
// eslint-disable-next-line no-unused-vars
const BRAND_MOCKUP_LIGHT_GREY = '#f7f7f7' // secondary background
const BRAND_MOCKUP_DARK_GREY = '#afbbc3' // secondary text

const base = BRAND_MOCKUP_BLACK
const primary = BRAND_MOCKUP_ORANGE
const secondary = BRAND_MOCKUP_BLACK // button text
const blue = BRAND_MOCKUP_GREY
const gray = BRAND_MOCKUP_GREY
const grayMedium = BRAND_MOCKUP_DARK_GREY
const grayLight = BRAND_MOCKUP_LIGHT_GREY
const grey = BRAND_MOCKUP_GREY
const orangeLight = BRAND_MOCKUP_LIGHT_ORANGE
const green = BRAND_MOCKUP_YELLOW
const greenPromo = BRAND_MOCKUP_YELLOW
const error = '#dd2c00'
const neutral1 = BRAND_MOCKUP_BLACK // offer title text
const neutral2 = BRAND_MOCKUP_BLACK // offer info text
const neutral3 = BRAND_MOCKUP_DARK_GREY // slider text
const neutral4 = BRAND_MOCKUP_BLACK // offer table border
const neutral5 = BRAND_MOCKUP_BLACK // offer box text
const white = BRAND_MOCKUP_WHITE
const footerColor = BRAND_MOCKUP_BLACK
const footerTextColor = BRAND_MOCKUP_WHITE
const darkerPrimary = BRAND_MOCKUP_BLACK // used for hover effect
const background = BRAND_MOCKUP_WHITE
const bannerborderbottom = `${BRAND_MOCKUP_DARK_GREY} 1px solid`
const ratePanel = BRAND_MOCKUP_YELLOW
const rateText = BRAND_MOCKUP_BLACK

export const color = {
  background,
  base,
  primary,
  secondary,
  blue,
  gray,
  grayMedium,
  grayLight,
  grey,
  orangeLight,
  green,
  greenPromo,
  error,
  gradient: `linear-gradient(90deg, ${primary}, ${BRAND_MOCKUP_YELLOW})`,
  link: BRAND_MOCKUP_ORANGE,
  neutral1,
  neutral2,
  neutral3,
  neutral4,
  neutral5,
  white,
  footerColor,
  footerTextColor,
  darkerPrimary,
  transparent: '#ffffff00',
  containerBackground: 'transparent',
  bannerColor: BRAND_MOCKUP_BLACK,
  bannerTextColor: BRAND_MOCKUP_WHITE,
  bannerborderbottom,
  bannerShadow: 'transparent',
  progressBarColor: BRAND_MOCKUP_YELLOW,
  progressBarBackground: BRAND_MOCKUP_WHITE,
  buttonTextColor: BRAND_MOCKUP_WHITE,
  buttonColor: primary,
  buttonBorder: BRAND_MOCKUP_BLACK,
  slider: primary,
  dropdown: base,
  ratePanel,
  rateText,
  offerDetails: BRAND_MOCKUP_BLACK,
  offerShortDescription: ratePanel,
  formField: BRAND_MOCKUP_NAVY,
  circleCheckBackground: primary,
  energyProductIconBackground: primary,
  energyProductIcon: BRAND_MOCKUP_NAVY,
  sliderThumbShadow: 'none',
}

export const assets = {}

export const logoConfig = {
  localPath: logo,
  url: '',
  width: 'auto',
  height: '50px',
  padding: '10px',
  backgroundColor: 'transparent',
  useLocal: true,
  logo,
  progressBarImage: {
    custom: true,
    name: 'think',
    height: '50px',
    width: 'auto',
    stepImageNames: {
      1: 'think-home',
      2: 'think-light',
      3: 'think-lock',
      4: 'think-card',
    },
    filter: 'grayscale(100%)',
  },
  header: {
    height: '60px',
  },
  tablet: { width: 'auto', height: '60px' },
}

const baseFamily = "'Helvetica Neue', Helvetica, Arial, sans-serif"
const customFont = 'Inter'

const titleFont = 'Neue Kabel'
const titleFontFamily = `${titleFont}, Verdana, Geneva, sans-serif`

export const font = {
  extraBold: '700',
  semiBold: '600',
  medium: '400',
  normal: '350',
  button: '400',
  pageTitle: '600',
  heading: '500',
  baseFamily,
  customFont,
  customFamily: `${customFont}, ${baseFamily}`,
  customTitleFamily: titleFontFamily,
  sizes: {
    small: '16px',
    default: '25px',
    large: '35px',
    pageTitle: {
      phone: '35pt',
      tablet: '75px',
    },
    heading: {
      phone: '25pt',
      tablet: '43px',
    },
    button: { phone: '20pt', tablet: '25px' },
  },
}

export const fontFace = `
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

@font-face {
  font-family: ${titleFont};
  src: url('/fonts/neue-kabel/Neue-Kabel-Bold.ttf') format('opentype');
}
`

export const features = {
  DISPLAY_REFERRAL_NAME: true,
  CALL_HEADER: false,
  CALL_FOOTER: true,
  CALL_FOOTER_PHONE: true,
  CALL_FOOTER_EMAIL: true,
  ONLINE_SUPPORT_STATUS_HEADER: false,
  REQUIRE_FULL_SOCIAL: false,
  HEADER: {
    position: 'relative',
    links: [
      { display: <Trans>About Us</Trans>, link: companyInfo.aboutUsLink },
      { display: <Trans>Blog</Trans>, link: companyInfo.blogLink },
      { display: companyInfo.phone },
    ],
  },
  BACKGROUND: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: '50% auto',
    backgroundPosition: '-30% 300px',
  },
  LOCALE_HEADER: false,
  HORIZONTAL_VIEW: true,
  V2_THEME: true,
  ENERGY_SLIDER_DEFAULT: '1',
}

export const theme = {
  layout: 'fullPage',
  progressPanel: {
    type: 'minimal',
    logo: false,
    textColor: BRAND_MOCKUP_BLACK,
    activeColor: BRAND_MOCKUP_ORANGE,
    inactiveColor: BRAND_MOCKUP_GREY,
  },
  buttons: {
    borderRadius: '0px',
    lineHeight: '2',
    shadowed: true,
    after: `
      content: '->';
      margin-left: 1rem;
      white-space: nowrap;
    `,
    primary: {
      color: BRAND_MOCKUP_BLACK,
      backgroundColor: BRAND_MOCKUP_ORANGE,
      borderColor: BRAND_MOCKUP_BLACK,
      shadowColor: BRAND_MOCKUP_BLACK,
      hover: {
        color: BRAND_MOCKUP_ORANGE,
        backgroundColor: BRAND_MOCKUP_WHITE,
        shadowColor: BRAND_MOCKUP_ORANGE,
      },
      disabled: {
        backgroundColor: false,
        '&:hover': {
          color: BRAND_MOCKUP_BLACK,
          backgroundColor: BRAND_MOCKUP_ORANGE,
          '&::before': {
            backgroundColor: BRAND_MOCKUP_BLACK,
          },
        },
      },
    },
    secondary: {
      color: BRAND_MOCKUP_WHITE,
      backgroundColor: BRAND_MOCKUP_NAVY,
      borderColor: BRAND_MOCKUP_BLACK,
      shadowColor: BRAND_MOCKUP_DARK_GREY,
      hover: {
        color: BRAND_MOCKUP_NAVY,
        backgroundColor: BRAND_MOCKUP_WHITE,
        shadowColor: BRAND_MOCKUP_YELLOW,
      },
      disabled: {
        backgroundColor: false,
        '&:hover': {
          color: BRAND_MOCKUP_WHITE,
          backgroundColor: BRAND_MOCKUP_NAVY,
          '&::before': {
            backgroundColor: BRAND_MOCKUP_DARK_GREY,
          },
        },
      },
    },
  },
  inputs: {
    borderRadius: '0px',
    borderColor: BRAND_MOCKUP_BLACK,
    label: { marginLeft: '0', fontSize: '25px', fontWeight: font.medium },
    required: { '::after': { content: "'*'" } },
    checkSize: '25px',
    checkStyle: 'messy',
    checkAlign: 'baseline',
  },
  linkStyles: {
    inline: {
      color: BRAND_MOCKUP_BLACK,
      textDecoration: 'underline',
      '&:hover': {
        color: BRAND_MOCKUP_ORANGE,
      },
    },
  },
  textEmphasis: {
    color: BRAND_MOCKUP_YELLOW,
    variant: 'shadowed',
  },
}
